module.exports = __webpack_public_path__ + "static/media/patalo_saaa.3bf4c3f2.ogg";